<template>
    <div>
        <div class="columns">
            <div class="column">
                <e-field>
                    <display-content :content="activityContent.content" />
                </e-field>
            </div>
        </div>

        <activity-completion-action-row>
            <e-tooltip
                position="is-top"
                :active="submitBlockedByExistingGrade"
                :label="translate('activity_graded_no_submissions_allowed')"
                multilined
            >
                <e-button
                    v-if="canShowSubmit"
                    :loading="isLoading"
                    :disabled="disabled"
                    type="is-primary"
                    @click="submit"
                    @keyup="submit"
                >
                    {{ translate('mark_complete') }}
                </e-button>
            </e-tooltip>
        </activity-completion-action-row>

        <div v-if="!readOnly && canViewSubmissions" class="columns">
            <div class="column">
                <submissions :namespace="namespace" @fetch-submissions="toggleSubmissionLoading" />
            </div>
        </div>
    </div>
</template>

<script>
import { getCurrentInstance } from 'vue';
import { useI18n } from 'vue-i18n';
import ActivityCompletionActionRow from '@/components/activity-types/course-activity-types/ActivityCompletionActionRow.vue';
import Submissions from '@/components/activity-types/course-activity-types/activities/Submissions.vue';
import DisplayContent from '@/components/editor/DisplayContent.vue';
import { useActivity } from '@/composables/useActivity.js';

export default {
    name: 'ViewInformation',

    components: {
        ActivityCompletionActionRow,
        DisplayContent,
        Submissions,
    },

    props: {
        namespace: {
            type: String,
            default: null,
        },

        uuid: {
            type: String,
            default: null,
        },

        readOnly: {
            type: Boolean,
            default: false,
        },

        provideSubmissions: {
            type: Array,
            required: false,
            default: () => null,
        },
    },

    setup(props, ctx) {
        const { t: translate } = useI18n();
        const instance = getCurrentInstance();
        const api = useActivity(props, ctx, { getPayload: () => instance.proxy.payload });

        return { translate, ...api };
    },

    computed: {
        payload() {
            return {
                uuid: this.activity.uuid,
                course_id: this.courseId,
                activity_id: this.activityId,
                activity_type: this.get('activity_type'),
                activity_submission: [],
            };
        },
    },
};
</script>
